import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="border-b border-line bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-34" data-mp="3ofhvxagdxdx7">
      <SectionHeading eyebrow="Avant et après" title="Arrêtez d’improviser face à une créatinine élevée" subtitle="Commencez à décider comme si un néphrologue était assis à vos côtés à chaque consultation." data-id="element-35" data-mp="3sg1qq7dhk5g6" />

      <div className="mx-auto mt-10 grid w-full max-w-5xl grid-cols-1 gap-5 lg:grid-cols-2" data-id="element-36" data-mp="3jihrf3z6oj87">
        <div className="flex flex-col rounded-2xl border border-red-900/40 bg-[#170D0F] p-5 sm:p-6" data-id="element-37" data-mp="34pxp25juyfrt">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-red-500/15 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-red-300" data-id="element-38" data-mp="39oiq276xp3hb">
            Avant
          </span>
          <h3 className="mt-4 font-display text-2xl font-extrabold leading-tight text-white" data-id="element-39" data-mp="30rzyayafvlmb">
            Vous décidez dans l’incertitude
          </h3>
          <ul className="mt-5 flex-1 space-y-4" data-id="element-40" data-mp="t1x9ytvr836z">
            {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-41" data-mp="171oqp2dnnxoo">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-500/15" data-id="element-42" data-mp="170dlcy4kahvg">
                  <XIcon className="h-3.5 w-3.5 text-red-400" aria-hidden="true" data-id="element-43" data-mp="edsv60ztobth" />
                </span>
                <span className="text-[14px] leading-relaxed text-slate-300" data-id="element-44" data-mp="9fhmvup6e9dd">{item}</span>
              </li>)}
          </ul>
          <p className="mt-auto pt-6 text-[14px] italic leading-relaxed text-red-200/80" data-id="element-45" data-mp="o5gjvu4zver9">
            Vous quittez la consultation en pensant : « J’espère avoir pris la bonne décision. »
          </p>
        </div>

        <div className="flex flex-col rounded-2xl border border-lime/35 bg-[#0C1810] p-5 sm:p-6" data-id="element-46" data-mp="3rr4aveidco5c">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-lime/15 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-lime" data-id="element-47" data-mp="3mtm5fy3k8r23">
            Avec la Route Rénale™
          </span>
          <h3 className="mt-4 font-display text-2xl font-extrabold leading-tight text-white" data-id="element-48" data-mp="1vnhiioxnj5h2">
            Vous décidez avec un chemin clair
          </h3>
          <ul className="mt-5 flex-1 space-y-4" data-id="element-49" data-mp="24h2y2ahn4qrj">
            {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-50" data-mp="17sn3fzzobr7k">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-lime/15" data-id="element-51" data-mp="17u83g54rc2ct">
                  <CheckIcon className="h-3.5 w-3.5 text-lime" aria-hidden="true" data-id="element-52" data-mp="1gsthbmzaat79" />
                </span>
                <span className="text-[14px] leading-relaxed text-slate-200" data-id="element-53" data-mp="1lref7fr2d0sj">{item}</span>
              </li>)}
          </ul>
          <p className="mt-auto pt-6 text-[14px] font-semibold leading-relaxed text-lime" data-id="element-54" data-mp="2s6x9qoq849a7">
            Le résultat est simple : le patient ressent de la sécurité. Vous aussi.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-55" data-mp="379ypfgf1m81x">
        <CTAButton label="Je veux décider en toute sécurité" caption="+300 pages cliniques • 6 volumes premium • 5 bonus • 100 % numérique" data-id="element-56" data-mp="32b59zig746z4" />
      </div>
    </section>;
}